"use strict";
/**
 * Collection Database Record Types
 *
 * Pattern Collections system - user-curated groups of patterns
 * Based on PATTERN-COLLECTIONS-AGGREGATION.md specification
 *
 * All three record types traced from:
 * lambda-utilities/src/utils/collection-database.ts → createCollection(), addPatternToCollection(), followCollection()
 */
Object.defineProperty(exports, "__esModule", { value: true });
